import React, { useEffect, useState } from "react";
import { FaHeart, FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import Header from '../HomePage/Header';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import HelpTrigger from '../HomePage/HelpTrigger';
import "./Products.css";
import MobileFilters from "./MobileFilters";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Products = () => {
  const [filters, setFilters] = useState({
    category: [],
    price: [],
    material: [],
    metal: [],
    type: []
  });
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const navigate = useNavigate();
    const [similarProducts, setSimilarProducts] = useState([]);

  const categories = ["Rings", "Earrings", "Pendants", "Kids Jewellery", "Bracelets"];
  const prices = ["10,000 - 20,000", "20,000 - 30,000", "30,000 - 50,000", "1,00,000 -3,00,000"];
  const materials = ["Gold", "Diamond", "Gemstone"];
  const metals = ["22Kt", "18Kt", "14Kt"];

  const categoryTypes = {
    Rings: ["Bands", "Engagement", "Mens"],
    Earrings: ["Studs", "Drops & Danglers", "Hoops & Huggies", "Pearls"],
    Pendants: ["Pendant Sets", "Necklaces"],
    "Kids Jewellery": ["Earrings", "Pendants"]
  };

  // const products = [
  //   { id: 1, name: "Diamond Engagement Ring", price: 25000, latest: true, image: "https://spinellejewelry.com/cdn/shop/files/R-30048White1.jpg?v=1720256590&width=750" },
  //   { id: 2, name: "Gold Stud Earrings", price: 12000, latest: false, image: "https://spinellejewelry.com/cdn/shop/files/R-30048Yellow1.jpg?v=1742283250&width=750" },
  //   { id: 3, name: "Pearl Necklace", price: 35000, latest: true, image: "https://spinellejewelry.com/cdn/shop/files/R-30048Rose1.jpg?v=1720256590&width=750" },
  //   { id: 4, name: "Men’s Wedding Band", price: 18000, latest: false, image: "https://spinellejewelry.com/cdn/shop/files/R-30048Rose1.jpg?v=1720256590&width=750" },
  //       { id: 5, name: "Diamond Engagement Ring", price: 25000, latest: true, image: "https://spinellejewelry.com/cdn/shop/files/R-30048Rose1.jpg?v=1720256590&width=750" },
  //   { id: 6, name: "Gold Stud Earrings", price: 12000, latest: false, image: "https://spinellejewelry.com/cdn/shop/files/R-30048Rose1.jpg?v=1720256590&width=750" },
  //   { id: 7, name: "Pearl Necklace", price: 35000, latest: true, image: "https://spinellejewelry.com/cdn/shop/files/R-30048Rose1.jpg?v=1720256590&width=750" },
  //   { id: 8, name: "Men’s Wedding Band", price: 18000, latest: false, image: "https://spinellejewelry.com/cdn/shop/files/R-30048Rose1.jpg?v=1720256590&width=750" }
  // ];


  const [products, setProducts] = useState([]);
  const [productImages, setProductImages] = useState([]);
  
  // Fetch products and images from the backend API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const productsResponse = await axios.get('https://spinelleapi.emedha.in/user/auth/api/products');
        const imagesResponse = await axios.get('https://spinelleapi.emedha.in/user/auth/api/product_images');
        
        setProducts(productsResponse.data);
        setProductImages(imagesResponse.data);
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, []);

  const [filteredProducts, setFilteredProducts] = useState([]);


useEffect(() => {
  // If you want to filter the products after the user selects filters
  const filteredProducts = filterProducts();
  setFilteredProducts(filteredProducts);
}, [filters]);

    const getImagesForProduct = (productId) => {
    return productImages.filter(image => image.product_id === productId);
  };



const toggleFilter = (type, value) => {
  setFilters((prev) => {
    const updated = prev[type].includes(value)
      ? prev[type].filter((v) => v !== value)
      : [...prev[type], value];
    return { ...prev, [type]: updated };
  });
};


  // const handleApplyFilters = (selectedFilters) => {
  //   setFilters((prevFilters) => ({
  //     ...prevFilters,
  //     category: selectedFilters.Category || [],
  //     price: selectedFilters.Price || [],
  //     material: selectedFilters.Material || [],
  //     metal: selectedFilters.Metal || []
  //   }));
  //   setMobileFilterOpen(false); // Close the filter modal after applying filters
  // };


  const handleApplyFilters = (selectedFilters) => {
  setFilters((prevFilters) => ({
    ...prevFilters,
    category: selectedFilters.Category || [],
    price: selectedFilters.Price || [],
    material: selectedFilters.Material || [],
    metal: selectedFilters.Metal || [],
    type: selectedFilters.Type || []
  }));
  setMobileFilterOpen(false); // Close the filter modal after applying filters
};


    const [activeImageIndexes, setActiveImageIndexes] = useState({});


  const handlePrevImage = (productId) => {
    setActiveImageIndexes((prevIndexes) => {
      const images = getImagesForProduct(productId);
      const currentIndex = prevIndexes[productId] || 0;
      const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
      return { ...prevIndexes, [productId]: newIndex };
    });
  };

  const handleNextImage = (productId) => {
    setActiveImageIndexes((prevIndexes) => {
      const images = getImagesForProduct(productId);
      const currentIndex = prevIndexes[productId] || 0;
      const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
      return { ...prevIndexes, [productId]: newIndex };
    });
  };


const filterProducts = () => {
  return products.filter((product) => {
    // Category Filter
    if (filters.category.length && !filters.category.includes(product.category)) {
      return false;
    }

    // Price Filter
    if (filters.price.length && !filters.price.some((range) => {
      const [minPrice, maxPrice] = range.split('-').map((price) => {
        return parseInt(price.replace(/,/g, '').trim(), 10); // Remove commas and convert to number
      });
      return product.price >= minPrice && product.price <= maxPrice;
    })) {
      return false;
    }

    // Material Filter
    if (filters.material.length && !filters.material.includes(product.material)) {
      return false;
    }

    // Metal Filter
    if (filters.metal.length && !filters.metal.includes(product.metal)) {
      return false;
    }

    // Type Filter (for selected category)
    if (filters.type.length && filters.category.length === 1 && !filters.type.includes(product.type)) {
      return false;
    }

    return true;
  });
};


useEffect(() => {
  setFilteredProducts(filterProducts()); // Apply filters on product load
}, [products, filters]);


const [sortOption, setSortOption] = useState(''); // Track the selected sort option


const sortProducts = (products, sortOption) => {
  switch (sortOption) {
    case 'Newest':
      return products.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Assuming `created_at` is a field for date
    case 'Price: Low to High':
      return products.sort((a, b) => b.price - a.price);
    case 'Price: High to Low':
      return products.sort((a, b) => a.price - b.price);
    case 'Best Selling':
      // Assuming you have a `sales` field that tracks the number of units sold
      return products.sort((a, b) => b.sales - a.sales);
    default:
      return products;
  }
};


const handleSortChange = (event) => {
  const selectedOption = event.target.value;
  setSortOption(selectedOption); // Update the selected sort option
};


useEffect(() => {
  const sortedProducts = sortProducts(filteredProducts, sortOption);
  setFilteredProducts(sortedProducts); // Update the filtered products with the sorted list
}, [sortOption, filteredProducts]);

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`); // Navigate to ProductDetails page with the product ID
  };
  
    const handleFilterChange = ({ category }) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      category: category ? [category] : prevFilters.category, // Update only the category
    }));
  };
  
  return (

 <>
       <Header />
      <Navbar  onFilterChange={handleFilterChange} />

    <div className="products-page">
      {/* Top Bar */}
  <div className="products-top-bar">
        <span className="products-count">Showing {filteredProducts.length} products</span>
        <select className="sort-select" onChange={handleSortChange}>
          <option value="">Sort by</option>
          <option value="Newest">Newest</option>
          <option value="Price: Low to High">Price: Low to High</option>
          <option value="Price: High to Low">Price: High to Low</option>
          <option value="Best Selling">Best Selling</option>
        </select>
      </div>

      <div className="products-layout">
        {/* Left Filters (Desktop) */}
        <aside className="filters-section">
          <h3>Category</h3>
          {categories.map((c) => (
            <label key={c}>
              <input
                type="checkbox"
                checked={filters.category.includes(c)}
                onChange={() => toggleFilter("category", c)}
                style={{ marginRight: '5px' }} 
              />
              {c}
            </label>
          ))}

          <h3>Price</h3>
          {prices.map((p) => (
            <label key={p}>
              <input
                type="checkbox"
                checked={filters.price.includes(p)}
                onChange={() => toggleFilter("price", p)}
                      style={{ marginRight: '5px' }} 
              />
              {p}
            </label>
          ))}

          <h3>Material</h3>
          {materials.map((m) => (
            <label key={m}>
              <input
                type="checkbox"
                checked={filters.material.includes(m)}
                onChange={() => toggleFilter("material", m)}
                      style={{ marginRight: '5px' }} 
              />
              {m}
            </label>
          ))}

          <h3>Metal</h3>
          {metals.map((m) => (
            <label key={m}>
              <input
                type="checkbox"
                checked={filters.metal.includes(m)}
                onChange={() => toggleFilter("metal", m)}
                      style={{ marginRight: '5px' }} 
              />
              {m}
            </label>
          ))}

          {/* Conditional Type Filters */}
          {filters.category.length === 1 && categoryTypes[filters.category[0]] && (
            <>
              <h3>{filters.category[0]} Type</h3>
              {categoryTypes[filters.category[0]].map((t) => (
                <label key={t}>
                  <input
                    type="checkbox"
                    checked={filters.type.includes(t)}
                    onChange={() => toggleFilter("type", t)}
                          style={{ marginRight: '5px' }} 
                  />
                  {t}
                </label>
              ))}
            </>
          )}
        </aside>

      

  <section className="products-grid">
  {filteredProducts.map((product) => {
    const images = getImagesForProduct(product.id);
    const activeImageIndex = activeImageIndexes[product.id] || 0; // Get the active image index or default to 0
    const mainImage = images.length ? images[activeImageIndex].image_path : "";

    return (
      <div className="product-card" key={product.id} >
        <div className="product-image-container">
          <img src={mainImage} alt={product.name} />
          <FaHeart className="wishlist-icon" />
          <div className="image-slider-arrows">
            <FaChevronLeft onClick={() => handlePrevImage(product.id)} />
            <FaChevronRight onClick={() => handleNextImage(product.id)} />
          </div>
        </div>
        <div className="product-info" onClick={() => handleProductClick(product.id)}>
          <h4>{product.name}</h4>
          <p>₹{parseFloat(product.price_18kt).toLocaleString()}</p>
        </div>
      </div>
    );
  })}
</section>


      </div>

      {/* Mobile Bottom Bar */}
<div className="mobile-bottom-bar">
  <div className="sort-section">
    <select className="sort-dropdown" onChange={handleSortChange}>
      <option>Sort by</option>
      <option>Newest</option>
      <option>Price: Low to High</option>
      <option>Price: High to Low</option>
      <option>Best Selling</option>
    </select>
  </div>
  <button className="filter-button" onClick={() => setMobileFilterOpen(true)}>
    Filters
  </button>
</div>

      {/* Mobile Filter Modal */}
     {mobileFilterOpen && (
          <MobileFilters onClose={() => setMobileFilterOpen(false)} onApply={handleApplyFilters} />
        )}

    </div>
    <div className="desktop">
     <Footer />
     </div>
   
    </>
  );
};

export default Products;
